module.exports = __webpack_public_path__ + "img/productcode-icon.0a3c9853.svg";